module.exports = __webpack_public_path__ + "static/media/Himanshu_Kamdi.efa7fb8e.jpg";